import { connect } from 'react-redux';
import { beginCommentAwardBadgeFlow } from '../../../coreBadge/redux/actionCreators';
const mapDispatchToProps = {
    awardBadge: beginCommentAwardBadgeFlow
};
export default connect(null, mapDispatchToProps);

//# sourceMappingURL=AwardBadgeButton.container.js.map